'use strict';

var o="display:block;border-color: black !important;border-width: 1px !important;font-size:small;padding:3px;background-color:#fff;letter-spacing:1px;font-family:sans-serif;color:#000;border-style:groove !important;",t="display: none;",r="background-color:gray;color:#fff",e="background-color:#fff;color:#000",i="position:absolute;width:50%;left:26%;background-color:white;border-radius:9px;padding:7px;text-align:center;overflow:auto;border-style:solid;border-width:thin;max-height:70%;top:15%;",s="position:absolute;width:50%;left:26%;background-color:white;border-radius:9px;padding:7px;text-align:center;border-style:solid;border-width:thin;height:75%;top:15%;";

exports.a = o;
exports.b = t;
exports.c = r;
exports.d = e;
exports.e = i;
exports.f = s;
